module.exports = __webpack_public_path__ + "img/oodle-logo.3abfc12c.png";